module.exports = __webpack_public_path__ + "img/school6.b69a3dbb.jpg";